import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BaseItemComponent } from '../base-item/base-item.component';

@Component({
  selector: 'usb-flight-item',
  templateUrl: './flight-item.component.html',
  styleUrls: ['./flight-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlightItemComponent extends BaseItemComponent {
  @Input() item: any;
  @Input() clientsSettingAppBooking: any;

  // FlyProductService arma item.itinerary con TODAS las opciones que trajo la
  // búsqueda por tramo, e item.selectedOptions con el optionId realmente
  // reservado por tramo (hoy siempre options[0], no hay UI para elegir otra).
  getSelectedOption(leg: any): any {
    const selectedId = (this.item?.selectedOptions || []).find((optionId: string) =>
      leg?.options?.some((option: any) => option.optionId === optionId)
    );
    return leg?.options?.find((option: any) => option.optionId === selectedId) || leg?.options?.[0];
  }

  getSegments(leg: any): any[] {
    return this.getSelectedOption(leg)?.segments || [];
  }

  getFirstSegment(leg: any): any {
    return this.getSegments(leg)[0];
  }

  getLastSegment(leg: any): any {
    const segments = this.getSegments(leg);
    return segments[segments.length - 1];
  }

  // Vuelo elegido "Por tramos": el item es un producto de UN solo tramo, cuyo
  // itinerary.legNumber siempre arranca en 1 (es una búsqueda one-way nueva),
  // así que no sirve para saber si es ida o vuelta — para eso está
  // item.direction (tag puesto por FlyProductService). "Vuelo completo"
  // (item sin direction) sigue usando legNumber como antes.
  getDirectionLabel(leg: any): string {
    if (this.item?.direction) {
      if (this.item.direction === 'IDA') return 'Ida';
      if (this.item.direction === 'VUELTA') return 'Regreso';
      return this.item.direction;
    }
    return leg?.legNumber === 1 ? 'Ida' : 'Regreso';
  }

  getStopsLabel(leg: any): string {
    const stops = this.getSegments(leg).length - 1;
    if (stops <= 0) return 'Directo';
    return stops === 1 ? '1 escala' : `${stops} escalas`;
  }

  // Aerolíneas operadoras de todos los segmentos del tramo (sin duplicar,
  // por si hay una escala con cambio de aerolínea).
  getAirlineCodes(leg: any): string {
    const codes = this.getSegments(leg).map((segment: any) => segment?.airline?.code).filter(Boolean);
    return Array.from(new Set(codes)).join(' / ');
  }

  getFlightNumbers(leg: any): string {
    return this.getSegments(leg)
      .map((segment: any) => `${segment?.airline?.code || ''}${segment?.flight?.number || ''}`)
      .join(', ');
  }

  getLegDuration(leg: any): string {
    return this.formatDuration(this.getSelectedOption(leg)?.duration);
  }

  formatDuration(minutes: number): string {
    if (!minutes) return '';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}h ${mins}m`;
  }
}
